import Glide from '@glidejs/glide';
import AOS from 'aos';
import Axios from 'axios';
import {CountUp} from 'countup.js/dist/countUp.js';
import {Utilities} from "./utilities";

/**
 * Our sites main js.
 */
class KbBSSite {

  /**
   * Our class constructor.
   */
  constructor() {
    this.body = document.querySelector("body");
    this.navBar = document.getElementById("wrapper-navbar");
    this.mainNav = document.getElementById("mega-menu-primary");
    this.jumpSelect = document.getElementById("jump-select");
    this.stickyBreak = 500;

    // Expose the objects to our window for our mutation observer.
    window.navBar = this.navBar;
    window.mainNav = this.mainNav;
    window.setNavBarHeight = this.setNavBarHeight;

    this.taxonomyDesktopDestination = document.getElementById("taxonomy-desktop-destination");
    this.taxonomyMobileDestination = document.getElementById("taxonomy-mobile-destination");
    this.countUpNumbers = document.querySelectorAll(".count-up-number");
    this.countUps = []; // Populated on load.

    AOS.init();
    this.mountGlideSliders();
    this.bindEventListeners();
  }

  /**
   * Bind all of our event listeners.
   */
  bindEventListeners() {
    const _self = this;
    // Bind a scroll listener to get the scroll position for our sticky navigation.
    document.addEventListener('scroll', function(e) {
      _self.handleStickyNav();

      if (_self.countUpNumbers !== null) {
        _self.startCountUps();
      }
    });

    if (_self.jumpSelect !== null) {
      _self.jumpSelect.addEventListener('change', function(e) {
        e.preventDefault();
        _self.jumpToSelection(e);
      });
    }

    window.addEventListener("load", function () {
      _self.maybeMoveTaxonomySingleTeamMember();

      if (_self.isiOS()) {
        _self.body.classList.add("is-ios");
      }

      if (_self.countUpNumbers !== null) {
        _self.countNumbersInit();
        _self.startCountUps();
      }
    });

    window.addEventListener("resize", function () {
      _self.maybeMoveTaxonomySingleTeamMember();
    });
  }

  /**
   * Start count ups when they become visible in viewport.
   */
  startCountUps() {
    const _self = this;

    if (_self.countUpNumbers !== null && _self.countUps !== null) {
      for (let i = 0; i < _self.countUpNumbers.length; i++) {
        if (Utilities.isElementInViewport(_self.countUpNumbers[i])) {
          for (let k = 0; k < _self.countUps.length; k++) {
            _self.countUps[i].start();
          }
        }
      }
    }
  }

  /**
   * Add countUps to our countsUps property on load.
   */
  countNumbersInit() {
    const _self = this;

    if (_self.countUpNumbers !== null) {
      for (let i = 0; i < _self.countUpNumbers.length; i++) {
        let id = _self.countUpNumbers[i].id;
        let countUpNumber = parseInt(_self.countUpNumbers[i].dataset.number);

        let countUp = new CountUp(id, countUpNumber);
        _self.countUps.push(countUp);
      }
    }
  }

  /**
   * Set the navbar height.
   */
  setNavBarHeight(mutationsList, observer) {
    mutationsList.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        if (mutation.target.classList.contains("show") && window.innerWidth <= 991) {
          navBar.style.height = "100%";
          navBar.style.overflowY = "scroll";
        }

        if (mutation.target.classList.contains("show") === false && window.innerWidth <= 991) {
          navBar.style.height = "";
          navBar.style.overflowY = "";
        }
      }
    })
  }

  /**
   * Jump to selection.
   */
  jumpToSelection(e) {
    const _self = this;

    if (_self.jumpSelect !== null) {
      if (_self.jumpSelect.value === "" || _self.jumpSelect.value === "#") {
        return;
      }

      if (e.target.options[e.target.selectedIndex].dataset.newTab === undefined) {
        window.location.href = _self.jumpSelect.value;
      } else {
        if (e.target.options[e.target.selectedIndex].dataset.newTab  === "_blank") {
          window.open(_self.jumpSelect.value, "_blank");
        } else {
          window.location.href = _self.jumpSelect.value;
        }
      }
    }
  }

  /**
   * Handle sticky nav.
   */
  handleStickyNav() {
    const _self = this;
    let adminBar = document.getElementById("wpadminbar");
    let bodyOffset = _self.navBar.offsetHeight;

    if (_self.navBar !== null) {
      if (window.scrollY >= _self.stickyBreak) {
        _self.body.style.paddingTop = bodyOffset + "px";

        _self.navBar.classList.add("fixed");

        // Account for wp admin bar if it is present.
        if (adminBar !== null && screen.width > 600) {
          _self.navBar.style.top = adminBar.offsetHeight + "px";
        }
      } else {
        _self.navBar.classList.remove("fixed");
        _self.body.style.paddingTop = 0 + "px";
        _self.navBar.style.top = 0 + "px";
      }
    }
  }

  /**
   * Mount glide sliders.
   */
  mountGlideSliders() {
    const sliders = document.querySelectorAll('.glide');
    const pageBuilderSliders = document.querySelectorAll('.page-builder-glide');
    const insightsGlide = document.getElementById('insights-glide');
    const articleContributionsGlide = document.getElementById('article-contributions-glide');
    const activitiesGlide = document.getElementById('activities-glide');

    if (sliders.length > 0) {
      new Glide('.glide', {
        autoplay: 4000,
        hoverpause: false,
        navigation: false,
      }).mount().on('run.before', evt => {
        evt.steps = '>'
        evt.direction = '|';
      });
    }

    if (pageBuilderSliders.length > 0) {
      for (let i = 0; i < pageBuilderSliders.length; i++) {
        let slideType = pageBuilderSliders[i].dataset.slideType;
        let autoplayTime = pageBuilderSliders[i].dataset.autoplayTime;
        let includeNavigation = (pageBuilderSliders[i].dataset.includeNavigation === "true");
        let sliderPerViewDesktop = parseInt(pageBuilderSliders[i].dataset.slidesPerViewDesktop);
        let sliderPerViewMobile = parseInt(pageBuilderSliders[i].dataset.slidesPerViewMobile);
        let sliderId = pageBuilderSliders[i].id;

        new Glide("#" + sliderId + "", {
          type: slideType,
          autoplay: autoplayTime,
          hoverpause: false,
          navigation: includeNavigation,
          perView: sliderPerViewDesktop,
          breakpoints: {
            991: {
              perView: sliderPerViewMobile
            }
          }
        }).mount().on('run.before', evt => {
          evt.steps = '>'
          evt.direction = '|';
        });
      }
    }

    if (insightsGlide !== null) {
      new Glide('#insights-glide', {
        type: 'carousel',
        autoplay: false,
        hoverpause: false,
        navigation: true,
        perView: 3,
        breakpoints: {
          991: {
            perView: 1
          }
        }
      }).mount().on('run.before', evt => {
        evt.steps = '>'
        evt.direction = '|';
      });
    }

    if (articleContributionsGlide !== null) {
      new Glide('#article-contributions-glide', {
        type: 'carousel',
        autoplay: false,
        hoverpause: false,
        navigation: true,
        perView: 3,
        breakpoints: {
          991: {
            perView: 1
          }
        }
      }).mount().on('run.before', evt => {
        evt.steps = '>'
        evt.direction = '|';
      });
    }

    if (activitiesGlide !== null) {
      new Glide('#activities-glide', {
        type: 'carousel',
        autoplay: false,
        hoverpause: false,
        navigation: true,
        perView: 2,
        breakpoints: {
          991: {
            perView: 1
          }
        }
      }).mount().on('run.before', evt => {
        evt.steps = '>'
        evt.direction = '|';
      });
    }
  }

  /**
   * Move the taxonomy html to appropriate div for mobile.
   */
  maybeMoveTaxonomySingleTeamMember() {
    const _self = this;

    if (_self.taxonomyDesktopDestination !== null && _self.taxonomyMobileDestination !== null) {
      if (screen.width <= 767) {
        // First check if the destination inner html is empty.
        if (_self.taxonomyMobileDestination.innerHTML === "" && _self.taxonomyDesktopDestination.innerHTML !== "" ) {
          _self.taxonomyMobileDestination.innerHTML = _self.taxonomyDesktopDestination.innerHTML;
          _self.taxonomyDesktopDestination.innerHTML = "";
        }
      } else {
        if (_self.taxonomyDesktopDestination.innerHTML === "" && _self.taxonomyMobileDestination.innerHTML !== "" ) {
          _self.taxonomyDesktopDestination.innerHTML = _self.taxonomyMobileDestination.innerHTML;
          _self.taxonomyMobileDestination.innerHTML = "";
        }
      }
    }
  }

  /**
   * Check if is iOS device.
   *
   * @returns {boolean|boolean}
   */
  isiOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}

const site = new KbBSSite();

const mutationObserver = new MutationObserver(setNavBarHeight);
mutationObserver.observe(mainNav, {attributes: true});